import util from "./_util";

const { request } = util;

export default {
  // 添加
  projectAdd(data) {
    return request.post("/Engineering/Save_engineering", data);
  },

  // 删除
  projectDel(params) {
    return request.get("/Engineering/delete_engineering?ids=" + params);
  },

  // 修改
  prijectUpdate(data) {
    return request.post("/Engineering/Save_engineering", data);
  },
};
